// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2987":"003cb099905403ce","8998":"c7c2dcd5419a841b"}[chunkId] + ".js";
};